import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CalculatorState } from '.';
import { Loading, RoundedPaper } from '../../lib/components';
import { CalculatorIcon, EmployeeCalculatingIcon, ResetIcon } from '../../lib/icons';
import { Button } from '../../lib/components/atomic/button';

interface Props {
  state: CalculatorState;
  text?: string;
  canCalculate?: boolean;
  canReset?: boolean;
  onResetClicked: () => void;
  onSubmitClicked: () => void;
  className?: string;
}

export const FormStateCard: FC<Props> = ({
  state,
  canCalculate = true,
  canReset = true,
  onResetClicked,
  onSubmitClicked,
  className
}) => {
  const { t } = useTranslation();
  return (
    <RoundedPaper
      className={className}
      sx={{
        position: 'absolute',
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        '@keyframes fadeOut': {
          '0%': {
            opacity: 1,
            visibility: 'visible'
          },
          '99%': {
            opacity: 0,
            visibility: 'visible'
          },
          '100%': {
            opacity: 0,
            visibility: 'hidden'
          }
        },
        '@keyframes fadeIn': {
          '0%': {
            opacity: 0,
            visibility: 'hidden'
          },
          '1%': {
            opacity: 0,
            visibility: 'visible'
          },
          '100%': {
            opacity: 1,
            visibility: 'visible'
          }
        },
        '&.fadeOut': {
          animationName: 'fadeOut',
          animationDuration: '1s',
          animationFillMode: 'forwards'
        },
        '&.fadeIn': {
          animationName: 'fadeIn',
          animationDuration: '1s',
          animationFillMode: 'forwards'
        }
      }}
    >
      <Box flex={1} />
      <Box flex={1} padding="1rem">
        <EmployeeCalculatingIcon height={180} width={180} sx={{ marginX: 'auto' }} />
        <Typography textAlign="center" variant="h3" marginTop={3}>
          {t('calculator:FORM_STATE_SIDEBAR_TITLE', { context: state })}
        </Typography>
        <Typography textAlign="center"></Typography>
      </Box>
      <Box sx={{ display: 'flex', flex: '1', gap: '1rem', margin: 'auto', padding: '1rem' }}>
        {state === 'loading' ? (
          <Loading />
        ) : (
          <>
            <Button variant="secondary" onClick={onResetClicked} disabled={!canReset}>
              <ResetIcon />
              {t('common:RESET')}
            </Button>
            <Button onClick={onSubmitClicked} disabled={!canCalculate}>
              <CalculatorIcon />
              {t('common:CALCULATE')}
            </Button>
          </>
        )}
      </Box>
      <Box flex={1} />
    </RoundedPaper>
  );
};
